<template>
    <div class="rtb-campaign-form">
        <div class="rtb-campaign-form__inner">
            <header class="sms-request-page__header">
                <h1 class="page-title">{{ isEdit ? 'Редактировать заявку' : 'Новая заявка на SMS-рассылку' }}</h1>
                <a :href="indexUrl" class="btn btn--secondary">К списку</a>
            </header>

            <form class="form" @submit.prevent="save">
                <section class="rtb-form-section sms-request-page__identity">
                    <div class="field" data-field="name">
                        <label class="field__label" for="sms-request-name">Название</label>
                        <input
                            id="sms-request-name"
                            v-model="request.name"
                            type="text"
                            maxlength="255"
                            class="form-input"
                            :disabled="!writable"
                            :class="{ 'is-invalid': errors.name }"
                        />
                        <p v-if="errors.name" class="field__error">{{ errors.name }}</p>
                    </div>
                    <div class="field" data-field="client_name">
                        <label class="field__label" for="sms-request-client">Клиент</label>
                        <input
                            id="sms-request-client"
                            v-model="request.client_name"
                            type="text"
                            maxlength="255"
                            class="form-input"
                            :disabled="!writable"
                            :class="{ 'is-invalid': errors.client_name }"
                        />
                        <p class="section-hint">Попадает в шапку документа заявки.</p>
                        <p v-if="errors.client_name" class="field__error">{{ errors.client_name }}</p>
                    </div>
                    <div class="field" data-field="brand_name">
                        <label class="field__label" for="sms-request-brand">Бренд</label>
                        <input
                            id="sms-request-brand"
                            v-model="request.brand_name"
                            type="text"
                            maxlength="255"
                            class="form-input"
                            :disabled="!writable"
                            :class="{ 'is-invalid': errors.brand_name }"
                        />
                        <p v-if="errors.brand_name" class="field__error">{{ errors.brand_name }}</p>
                    </div>
                </section>

                <SmsRequestFields
                    :request="request"
                    :errors="errors"
                    :disabled="!writable"
                    :is-edit="isEdit"
                    :sending="sending"
                    :send-error="sendError"
                    :last-delivery="delivery"
                    :cities="smsConfig.cities || []"
                    :incomes="smsConfig.incomes || []"
                    :device-brands="smsConfig.device_brands || []"
                    :app-categories="smsConfig.app_categories || []"
                    :send-slots="smsConfig.send_slots || []"
                    @send="send"
                />

                <p v-if="generalError" class="field__error">{{ generalError }}</p>

                <div v-if="writable" class="sms-request-page__actions">
                    <button class="btn btn--primary" type="submit" :disabled="saving || sending">
                        {{ saving ? 'Сохранение…' : 'Сохранить' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import SmsRequestFields from './SmsRequestFields.vue';
import { useSmsRequestForm } from '../../../composables/useSmsRequestForm';

const props = defineProps({
    smsConfig: { type: Object, default: () => ({}) },
    smsRequest: { type: Object, default: null },
    lastDelivery: { type: Object, default: null },
    writable: { type: Boolean, default: false },
    saveUrl: { type: String, required: true },
    sendUrl: { type: String, default: '' },
    indexUrl: { type: String, required: true },
});

const {
    request,
    errors,
    generalError,
    saving,
    sending,
    sendError,
    lastDelivery: delivery,
    isEdit,
    save,
    send,
} = useSmsRequestForm(props);
</script>

<style scoped lang="scss">
.sms-request-page__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    margin-bottom: 16px;
}

.sms-request-page__identity {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 16px;
    margin-bottom: 16px;
}

.sms-request-page__actions {
    margin-top: 16px;
}
</style>
